export default __webpack_public_path__ + "static/media/gamecard-ishot.0c47fa2a.svg";